import React from 'react';
import Interweave from 'interweave';
import { Link } from 'react-router-dom';
import * as StyledFormAccepted from './formAccepted.styles';
import {
	Columns, Column, H1, Button
} from '../../base';
import { MINAR_SIDUR_URL } from '../../../constants/urls';
import ApartmentBox from '../../apartmentBox';

const FormAccepted = ({
	title,
	content,
	apartment
}) => {
	return (
		<StyledFormAccepted.Wrapper>
			<Columns>
				<Column tablet={6 / 12} desktopSmall={8 / 12}>
					<StyledFormAccepted.ContentWrapper>
						<H1 marginBottom="3rem">{title}</H1>
						<Interweave content={content} />
						<StyledFormAccepted.ButtonWrapper>
							<Link to="/">
								<Button>Aftur á forsíðu</Button>
							</Link>
							<Link to="/lausar-ibudir">
								<Button>Skoða íbúðir</Button>
							</Link>
							<Button
									as="a"
									href={MINAR_SIDUR_URL}
									target="_blank"
									rel="noopener noreferrer">
								{'Mínar síður'}
							</Button>
						</StyledFormAccepted.ButtonWrapper>
					</StyledFormAccepted.ContentWrapper>
				</Column>
				<Column tablet={6 / 12} desktopSmall={4 / 12}>
					<StyledFormAccepted.ApartmentBoxWrapper>
						<ApartmentBox apartment={apartment} />
					</StyledFormAccepted.ApartmentBoxWrapper>
				</Column>
			</Columns>
		</StyledFormAccepted.Wrapper>
	);
};

export default FormAccepted;
